import * as React from 'react';
import {
    EditBase,
    Form,
    SaveButton,
    Toolbar,
    useEditContext,
} from 'react-admin';
import { Card, CardContent, Box } from '@mui/material';

import { ResourceNotFound } from '@/components/misc/ResourceNotFound';
import {
    showMainSx,
    showPageRowSx,
} from '@/components/layout/showPageLayout';
import { ContractorOwnerInputs } from './ContractorOwnerInputs';
import { ContractorOwnerAside } from './ContractorOwnerAside';
import { ContractorOwner } from '@/types';

export const ContractorOwnerEdit = () => (
    <EditBase mutationMode="pessimistic" redirect="show">
        <ContractorOwnerEditContent />
    </EditBase>
);

const ContractorOwnerEditContent = () => {
    const { isPending, record, error } = useEditContext<ContractorOwner>();
    if (isPending) return null;
    if (error || !record) {
        return (
            <ResourceNotFound
                resourceLabel="Contractor"
                listPath="/contractor_owners"
                listLabel="Back to contractors"
            />
        );
    }
    return (
        <Box sx={showPageRowSx}>
            <ContractorOwnerAside link="show" />
            <Box sx={showMainSx}>
                <Form>
                    <Card>
                        <CardContent>
                            <ContractorOwnerInputs />
                        </CardContent>
                        <Toolbar>
                            <SaveButton />
                        </Toolbar>
                    </Card>
                </Form>
            </Box>
        </Box>
    );
};
